<template>
  <v-select
    class="vue-custom-select"
    :class="{
      'has-error': !!error,
      'select-blank': isBlank,
      [position]: position,
      'highlighted-first-option': highlightFirstOption,
      'hide-overflow': !isScrolledOptions
    }"
    :style="{ '--custom-select-flex-wrap': multiple ? 'wrap' : 'nowrap' }"
    :options="options"
    :searchable="searchable"
    :placeholder="placeholder"
    :label="label"
    :disabled="disabled"
    :multiple="multiple"
    :clearable="clearable"
    :filterable="filterable"
    :notfound="notfound"
    :components="{ OpenIndicator }"
    :selectable="(option) => !option.isSelectorGroupName"
    :taggable="taggable"
    :push-tags="pushTags"
    :highlight-first-option="highlightFirstOption"
    :required="required"
    :value="value"
    :inputId="inputId"
    :create-option="createOption"
    :reduce="reduce"
    @input="$emit('input', $event)"
    @search="$emit('search', $event)"
    @open="$emit('open', $event)"
    @close="$emit('close', $event)"
    @option:created="$emit('option:created', $event)"
  >
    <template #option="option">
      <slot :option="option" />
    </template>

    <template
      v-if="isForkSelector"
      #selected-option="{ ownerAlias, alias }"
    >
      {{ ownerAlias }}/{{ alias }}
    </template>

    <template #no-options>
      {{ notfound }}
    </template>

    <template #list-footer>
      <slot name="footer" />
    </template>

    <!-- <template #search="{attributes, events}">
        <input
            type="text"
            inputmode="text"
            class="vs__search"
            :required="required"
            v-bind="attributes"
            v-on="events"
        />
      </template> -->
  </v-select>
</template>

<script>
import vSelect from 'vue-select';
import '@/shared-modules/scss/vue-select.scss';

export default {
  name: 'CustomSelect',
  components: { vSelect },
  props: {
    clearable: { default: false },
    label: { default: 'title' },
    value: { default: '' },
    filterable: { default: true },
    disabled: { default: false },
    searchable: { default: false },
    placeholder: { default: null },
    isBlank: { default: false },
    multiple: { default: false },
    error: { default: null },
    isForkSelector: { default: false },
    notfound: { default: 'Совпадений не найдено' },
    selectable: { default: true },
    isGroupSelector: { default: false },
    taggable: { default: false },
    pushTags: { default: false },
    highlightFirstOption: { default: false },
    required: { default: false },
    inputId: { default: null },
    options: {
      default() {
        return [];
      }
    },
    placement: {
      default: 'bottom',
      type: String
    },
    position: {
      default: 'bottom',
      type: String
    },
    createOption: {
      type: Function
    },
    reduce: {
      type: Function
    },
    isScrolledOptions: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectModel: null,
      OpenIndicator: {
        render: (createElement) =>
          createElement('img', { attrs: { src: '/static/image/icons/angle-down.svg' } })
      }
      //   Deselect: {
      //     render: createElement => createElement('img', { attrs: { src: '/static/image/icons/close.svg'} }),
      //   },
    };
  }
};
</script>

<style lang="scss">
.v-select {
  --vs-search-input-placeholder-color: var(--gray);

  &.has-error .vs__dropdown-toggle {
    border-color: red !important;
  }

  .vs__dropdown-toggle {
    border-color: var(--border-color);
    cursor: pointer !important;
  }

  &.right {
    .vs__dropdown-menu {
      left: auto !important;
      right: 0 !important;
    }
  }

  &.select-blank {
    .vs__dropdown-toggle {
      border: none !important;
    }

    .vs__search {
      padding: 0 !important;
      margin: 0 !important;
    }

    .vs__actions {
      display: none;
    }

    .vs__dropdown-menu {
      border-top: 1px solid var(--vs-colors--lightest);
      border-radius: 3px;
    }

    .vs__selected {
      position: relative;
      padding-right: 13px;

      &:after {
        position: absolute;
        top: 50%;
        margin-top: -3px;
        right: 0;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 5px solid #ccc;
        display: block;
        content: '';
      }
    }
  }

  .vs__dropdown-toggle .vs__selected-options {
    min-width: 0;
    flex-wrap: var(--custom-select-flex-wrap);
    cursor: pointer;

    & > input {
      cursor: pointer;
    }
  }

  &.vs--single.vs--unsearchable.vs--open .vs__selected {
    position: relative !important;
  }

  &.vs--open.vs--searchable {
    .vs__dropdown-toggle .vs__selected-options {
      cursor: text !important;

      & > input {
        cursor: text !important;
      }
    }
  }

  .vs__selected {
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .vs__selected:has(button) {
    overflow: hidden;
    display: inline-block;
    // max-width: 100px;
    padding-right: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;

    & > button {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      padding-right: 5px;
      background: inherit;
    }
  }

  .vs__selected-options input {
    font-size: 14px;
  }

  .vs__clear {
    margin-right: 0;
  }
}

.vs__dropdown-option {
  padding-left: 10px;
  padding-right: 10px;
  width: 100%;
}

.vue-custom-select.hide-overflow {
  .vs__dropdown-menu {
    overflow: hidden;
  }
  .vs__dropdown-option {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.vs__dropdown-option--disabled {
  padding-top: 0.75rem;
  font-weight: normal;
  color: var(--gray);
  border-top: 1px solid var(--border-color) !important;
  background-color: var(--white);
  border-radius: 0 !important;
}

.highlighted-first-option ul li:first-child {
  margin-bottom: 4px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border-color, #dee2e6);
}
</style>
